export const FORM_INDEX = '__MANTINE_FORM_INDEX__';
